// extracted by mini-css-extract-plugin
export default {"inputContainer":"F24be","icon":"ieSXx","selectedText":"TBPtd","text":"hKZ8u"};